import '../blogs/Blogs.scss'
import { useParams, useNavigate } from 'react-router-dom'
import blogPosts from '../../assets/data/BlogPosts'
import PopularPosts from '../../assets/data/PopularPosts'
import blogHero from '../../assets/images/blogHero.png'
import Navbar from '../landing/components/Navbar'
import { Icon } from '@iconify/react'
import FaqsTACData from '../../assets/data/FaqsTACData'
import { useState } from 'react'
import Logo from '../../assets/images/logo-white.png'
import { Link } from 'react-router-dom'


const Blog = () => {

  const [selectedQuestion, setSelectedQuestion] = useState(0)

  const { id } = useParams()
  const navigate = useNavigate()
  const postIndex = Number(id)
  const post = blogPosts[postIndex]

  const relatedPosts = blogPosts.filter((_, i) => i !== postIndex).slice(0, 2)

  if (!post) return <p>Post not found.</p>

  return (
    <div className="blog-page">

      <Navbar use='privacy' />

      <div className='hero'>
        <div className='hero-wrapper flex flex-wrap justify-between'>
          <div className='left'>
            <div className='left-wrap'>
              <h1 className='gradient-text'>OUR BLOG NEWS</h1>
              <p>
                In a challenging logistics environment, our shipping
                integration solutions connect your business software with Qc
                Express logistic solutions. With modern APIs and a Shipment
                Visibility Webhook, you can automate shipping, track
                deliveries in real time, and streamline operations
                effortlessly, helping you navigate logistical challenges.
              </p>
              <div className='hero-btns'>
                <button className='first-btn'>Get Started</button>
                <button className='second-btn'>View Docs</button>
              </div>
            </div>
          </div>
          <div className='right'>
            <img src={blogHero} alt='programmer' />
          </div>
        </div>
      </div>
      
      <div className='blog-wrapper'>
        <div className='breadcrumb'>
          <span>Home</span>/<span className='active'>BLOG POST</span>
        </div>

        <div className='blog-container'>
          <div className='blog-left'>
            <div className='expanded-blog'>
              <img src={post.image} alt='Expanded Blog' />
              <div className='blog-info'>
                <p className='meta'>
                  <span>{post.author}</span> • <span>{post.date}</span>
                </p>
                <h2>{post.title}</h2>
                <p>{post.content}</p>
              </div>
            </div>

            <div className='related-posts'>
              <h3>Related Blog</h3>
              <div className='related-grid'>
                {relatedPosts.map((relPost, index) => (
                  <div className='blog-card small' key={index}>
                    <img src={relPost.image} alt='Related Blog' />
                    <div className='blog-info'>
                      <p className='meta'>
                        <span>{relPost.author}</span> • <span>{relPost.date}</span>
                      </p>
                      <h4>{relPost.title}</h4>
                      <p>{relPost.excerpt}</p>
                      <Link to={`/blog/${index}`}>
                        Learn More →
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className='blog-right'>
            <div className='sidebar-section'>
              <h4>Categories</h4>
              <div className='tags'>
                <span>Industry News</span>
                <span>Logistics Technology</span>
                <span>Delivery Safety Practices</span>
                <span>Route Optimization</span>
                <span>Real-Time Tracking</span>
                <span>Freight & Shipping</span>
              </div>
            </div>

            <div className='sidebar-section'>
              <h4>Tags</h4>
              <div className='tags'>
                <span>KPI Tracking</span>
                <span>Cost Reduction</span>
                <span>Markets Trends</span>
                <span>Insights</span>
                <span>AI in Logistics</span>
                <span>Real-Time Tracking</span>
                <span>Freight & Shipping</span>
              </div>
            </div>

            <div className='sidebar-section'>
              <h4>Popular post</h4>
              <ul className='popular-posts'>
                {PopularPosts.map((post, index) => (
                  <li key={index}>
                    <img src={post.image} alt='Thumbnail' />
                    <div className='text-content'>
                      <p className='title'>{post.title}</p>
                      <p className='description'>{post.subtext}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className='faqs'>
          <div className='wrapper'>
            <div className='top'>
              <h1 className='gradient-text'>
                frequently asked questions(FAQs)
              </h1>
              <p>
                Find answers to common inquiries in our Frequently Asked
                Questions (FAQ) section.
              </p>
            </div>
            <div className='faq-list'>
              {FaqsTACData.map((data, index) => (
                <div className='faq' key={index}>
                  <div
                    className='question flex justify-between'
                    onClick={() => setSelectedQuestion(index)}
                  >
                    <h3>{data.question}</h3>
                    <div>
                      {selectedQuestion === index ? (
                        <Icon icon='akar-icons:chevron-up' />
                      ) : (
                        <Icon icon='akar-icons:chevron-down' />
                      )}
                    </div>
                  </div>
                  {selectedQuestion === index && (
                    <div className='answer'>
                      <p>{data.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className='footer'>
          <div className='wrapper'>
            <div className='flex justify-between flex-wrap'>
              <div className='card logo'>
                <img src={Logo} alt='' />
                <p>
                  Your trusted partner in getting goods where they need to be,
                  fast and safe.
                </p>
              </div>

              <div className='card'>
                <h3>Contact Us</h3>
                <div className='flex'>
                  <div>
                    <div className='icon'>
                      <Icon icon='mdi:location' />
                    </div>
                  </div>
                  <div className='text'>
                    <p>Location:</p>
                    <p>
                      14A Olatunji Close, Off Continental Way, Ikosi GRA IV,
                      Magodo, Lagos-Nigeria.
                    </p>
                  </div>
                </div>
                <div className='flex'>
                  <div>
                    <div className='icon'>
                      <Icon icon='ic:baseline-phone' />
                    </div>
                  </div>
                  <div className='text'>
                    <p>Phone Number:</p>
                    <p>
                      +234 912 049 9852–7, +234 802 0549 655, +234 802 290 2446
                    </p>
                  </div>
                </div>
                <div className='flex'>
                  <div>
                    <div className='icon'>
                      <Icon icon='bxs:envelope' />
                    </div>
                  </div>
                  <div className='text'>
                    <p>Email:</p>
                    <p>customercare@quartzclassic.com</p>
                  </div>
                </div>
              </div>
              <div className='card'>
                <h3 className='newsletter-h3'>SUBSCRIBE TO OUR NEWSLETTER</h3>
                <input type='text' placeholder='Enter your email' />
                <br />
                <button onClick={() => navigate('/')}>Subscribe</button>
                <div className='socials'>
                  <a
                    href='https://www.instagram.com/qc_express?igsh=NjhyYWZtNm1lN3Rk'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <Icon icon='akar-icons:instagram-fill' />
                  </a>
                  <Icon icon='akar-icons:facebook-fill' />
                  <a
                    href='https://x.com/qc_express'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <Icon icon='akar-icons:twitter-fill' />
                  </a>
                </div>
              </div>
            </div>
            <hr />
            <p className='footer-p'>&copy; QC Express. All rights reserved.</p>
          </div>
        </div>
    </div>
  )
}

export default Blog